import React from "react";
import { connect } from "react-redux";
import { Channel } from "../../../types";
import { clearModal } from "../../../../modals/actions";
import ActionsModal from "../../../../modals/ActionsModal";

interface Props {
    currentUser: any;
    channel: Channel;
    muteBanRefresh: VoidFunction;
    clearModal: VoidFunction;
}

const MuteOptionsModal = ({
    currentUser,
    channel,
    muteBanRefresh,
    clearModal
}: Props) => {
    const sendBirdData = channel.sendBirdData;

    const completionCallback = (_: any, error: any) => {
        if (error) {
            window.alert(error);
        } else {
            clearModal();
            muteBanRefresh();
        }
    };

    const mute = (length?: number) => {
        if (length) {
            sendBirdData.muteUserWithUserId(
                currentUser.userId,
                length,
                "Generic",
                completionCallback
            );
        } else {
            sendBirdData.muteUserWithUserId(
                currentUser.userId,
                completionCallback
            );
        }
    };

    return (
        <ActionsModal
            actions={[
                { text: "Mute for:" },
                { text: "30 minutes", callback: () => mute(1800) },
                { text: "1 hour", callback: () => mute(3600) },
                { text: "1 day", callback: () => mute(86400) },
                { text: "Indefinitely", callback: () => mute() }
            ]}
        />
    );
};

const mapDispatchToProps = (dispatch: any) => ({
    clearModal: () => dispatch(clearModal())
});

export default connect(null, mapDispatchToProps)(MuteOptionsModal);
